import { IconButton, Tooltip, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { ValidScoreItem, ValidScoreWrapper } from '../styled';
import { ScoringType } from '../../Exams/types';
import Icons from '../../../components/icons';

export const getScoringTypeColumns = (
  handleEdit: (scoringType: ScoringType) => void,
  handleDelete: (scoringType: ScoringType) => void
): GridColDef[] => [
  {
    field: 'id',
    headerName: 'Id'
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 150,

    renderCell: (params) => (
      <Typography
        variant='body2'
        fontWeight={500}
        height={40}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: '100%'
        }}
      >
        {params.value}
      </Typography>
    )
  },
  {
    field: 'validScores',
    headerName: 'Valid Scores',
    flex: 1.5,
    minWidth: 200,

    renderCell: (params) => (
      <ValidScoreWrapper>
        {params.value?.map((score: string, index: number) => (
          <ValidScoreItem key={index}>{score}</ValidScoreItem>
        ))}
      </ValidScoreWrapper>
    )
  },
  {
    field: 'edit',
    headerName: 'Edit',
    flex: 0.5,
    maxWidth: 80,
    minWidth: 80,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <Tooltip title='Edit'>
        <IconButton onClick={() => handleEdit(params.row)}>
          <Icons.EditBlackOutlined />
        </IconButton>
      </Tooltip>
    )
  },
  {
    field: 'delete',
    headerName: 'Delete',
    flex: 0.5,
    maxWidth: 80,
    minWidth: 80,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      const TrashIcon = Icons.Delete;
      return (
        <Tooltip title='Delete'>
          <IconButton onClick={() => handleDelete(params.row)}>
            <TrashIcon width={20} height={20} />
          </IconButton>
        </Tooltip>
      );
    }
  }
];
